module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/soft-serve-machines/soft-serve-machines.component.scss
// module id = ./src/app/pages/soft-serve-machines/soft-serve-machines.component.scss
// module chunks = main